import {Env} from 'common/tool/Env';

export class Environment {
    public static getMode(): Env {
        switch (process.env.NODE_ENV) {
            case 'dev':
            case 'development':
                return Env.DEVELOPMENT;
            case 'prod':
            case 'production':
                return Env.PRODUCTION;
            case 'test':
                return Env.TEST;
        }

        return process.env.APP_ID === undefined ? Env.DEVELOPMENT : Env.PRODUCTION;
    }
}
